var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stockScoreDetailsTotal"},[_c('div',{staticClass:"ssdtTitle"},[_vm._v(_vm._s(_vm.$t('subScore.finalScore')))]),_c('div',{staticClass:"ssdtValue"},[_vm._v(_vm._s(_vm.normalizedScore))])])
}
var staticRenderFns = []

export { render, staticRenderFns }